export default __webpack_public_path__ + "static/media/dds5168_4p-3.0f9cf0df.png";